import { getAuthUserDashboardUrl } from "@castiero/web/common/getAuthUserDashboardUrl";
import LoginLayout from "@castiero/web/components/layouts/LoginLayout";
import { LoginForm } from "@castiero/web/components/login/LoginForm";
import authUserMiddleware from "@castiero/web/middleware/authUserMiddleware";
import localizationMiddleware from "@castiero/web/middleware/localizationMiddleware";
import { NextPage } from "next";

const Login: NextPage = () => {
  return (
    <LoginLayout page="login">
      <LoginForm />
    </LoginLayout>
  );
};

export const getServerSideProps = localizationMiddleware(
  authUserMiddleware(async (config, store) => {
    const redirect = getAuthUserDashboardUrl(config, store);
    if (redirect)
      return {
        redirect: {
          destination: redirect,
          permanent: false,
        },
      };

    return {
      props: {},
    };
  }, false)
);

export default Login;
